var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.account)?_c('div',{key:"account",staticClass:"flex-1 h-0",class:{ 'overflow-hidden': _vm.isTransitioning }},[_c('TransitionPage',{on:{"begin":function($event){_vm.isTransitioning = true},"end":function($event){_vm.isTransitioning = false}}},[_c('RouterView')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }